export default __webpack_public_path__ + "static/media/weightlosswithfamily@3x.042d0360.jpg";